import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import { MARK_LINK, NODE_PARAGRAPH, render } from 'storyblok-rich-text-react-renderer';
import { Link } from 'gatsby';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';
import FancyTitle from '../fancy-title';
import StoryBlokLink from '../StoryblokLink';
import StoryblokImage from './storyblok-image';
import { getStoryblokAlt } from '../../helpers/common';

function getImageSizes(filename, isMobile) {
  if (!filename) return isMobile ? '42vw' : '180px';
  const dims = filename.split('/')[5]?.split('x');
  const w = parseInt(dims?.[0], 10);
  const h = parseInt(dims?.[1], 10);
  const isWideStrip = w && h && (w / h) > 3;
  if (isWideStrip) {
    return isMobile ? '90vw' : '(max-width: 1024px) 90vw, 900px';
  }
  return isMobile ? '(max-width: 640px) 42vw, 180px' : '(max-width: 640px) 42vw, (max-width: 1024px) 30vw, 180px';
}

function ShopifyBadges({ blok }) {
  const { heading } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      <Container className="max-w-5xl mx-auto">
        <FancyTitle
          text={heading}
          tag="h2"
          textAlign="text-center"
        />
        <div className="mb-8">
          {render(blok.description, {
            markResolvers: {
              [MARK_LINK]: LinkResolver,
            },
            nodeResolvers: {
              // eslint-disable-next-line react/no-unstable-nested-components
              [NODE_PARAGRAPH]: (children) => (
                <p className="first-of-type:mt-0 last-of-type:mb-0 m-auto my-4" style={{ fontSize: '16px' }}>{children}</p>
              ),
            },
          })}
        </div>
        <>

          <div className="lg:flex lg:flex-nowrap lg:justify-center gap-10 items-center badges-container">
            {blok.badges.map((badge) => {
              const hasMobileImage = badge?.mobile_bage?.filename || badge?.badge?.mobile_bage?.filename;
              const mobileImageSrc = badge?.mobile_bage || badge?.badge?.mobile_bage;
              const desktopImageAlt = getStoryblokAlt(badge?.badge);
              const mobileImageAlt = getStoryblokAlt(
                badge?.mobile_bage,
                getStoryblokAlt(badge?.badge?.mobile_bage, desktopImageAlt),
              );
              const desktopImageSrc = badge?.badge;

              return (
                <div
                  key={badge?.badge?.filename}
                  className="flex items-center justify-center justify-self-center"
                >
                  {badge.link && badge.link.story ? (
                    <Link
                      to={`/${badge?.link?.story?.full_slug || badge?.link?.cached_url}`}
                      title={badge?.link_title || undefined}
                      rel="follow"
                      className="flex items-center justify-center"
                    >
                      {hasMobileImage && (
                        <StoryblokImage
                          src={mobileImageSrc}
                          alt={mobileImageAlt}
                          className="h-full w-auto object-contain lg:hidden"
                          imageClassName="!m-0 block"
                          sizes={getImageSizes(mobileImageSrc?.filename, true)}
                          ratio="auto"
                          figured={false}
                        />
                      )}
                      <StoryblokImage
                        src={desktopImageSrc}
                        alt={desktopImageAlt}
                        className={`h-full w-auto object-contain ${hasMobileImage ? 'hidden lg:block' : ''}`}
                        imageClassName="!m-0 block"
                        sizes={getImageSizes(desktopImageSrc?.filename, false)}
                        ratio="auto"
                        figured={false}
                      />
                    </Link>
                  ) : (
                    <>
                      {hasMobileImage && (
                        <StoryblokImage
                          src={mobileImageSrc}
                          alt={mobileImageAlt}
                          className="h-full w-auto object-contain lg:hidden"
                          imageClassName="!m-0 block"
                          sizes={getImageSizes(mobileImageSrc?.filename, true)}
                          ratio="auto"
                          figured={false}
                        />
                      )}
                      <StoryblokImage
                        src={desktopImageSrc}
                        alt={desktopImageAlt}
                        className={`h-full w-auto object-contain ${hasMobileImage ? 'hidden lg:block' : ''}`}
                        imageClassName="!m-0 block"
                        sizes={getImageSizes(desktopImageSrc?.filename, false)}
                        ratio="auto"
                        figured={false}
                      />
                    </>
                  )}
                </div>
              );
            })}
          </div>
          {(blok.cta_text || blok.button_text) && (blok.cta_link || blok.button_link) && (
            <div className="flex justify-center mt-8 lg:mt-12 pb-8 lg:pb-32">
              <StoryBlokLink
                to={
                (blok.cta_link?.story?.full_slug || blok.button_link?.story?.full_slug)?.replace('en/home', '/en').replace('home', '/')
                || blok.cta_link?.cached_url
                || blok.button_link?.cached_url
                || blok.cta_link?.url
                || blok.button_link?.url
                || '#'
              }
               title={blok.cta_link?.link_title || blok.button_link?.link_title || undefined}
               noFollow={true}
                className="button-primary"
                aria-label={blok.cta_link_aria}
              >
                {blok.cta_text || blok.button_text}
              </StoryBlokLink>
            </div>
          )}

        </>
      </Container>
    </div>
  );
}


export default ShopifyBadges;
